import React, { useState } from 'react';
import { oneOfType, node, string } from 'prop-types';
import classnames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { Dropdown } from '@fiverr-private/orca';
import IconWrapper from '../IconWrapper';
import './style.scss';

const SellerDropdown = ({ menu, triggerLabel, icon, tooltip, position }) => {
    const [isOpen, setIsOpen] = useState(false);
    const setOpen = () => setIsOpen(true);
    const setClose = () => setIsOpen(false);

    return (
        <Dropdown
            menu={menu}
            position={position}
            onOpen={setOpen}
            onClose={setClose}
            containerClassName="sellerdropdown-container-box"
        >
            {icon ? (
                <IconWrapper isOpen={isOpen} tooltip={tooltip}>
                    <Icon size={19}>{icon}</Icon>
                </IconWrapper>
            ) : (
                <Dropdown.Button
                    label={triggerLabel}
                    className={classnames('seller-main-item', { 'seller-dropdown-open': isOpen })}
                />
            )}
        </Dropdown>
    );
};

SellerDropdown.propTypes = {
    menu: Dropdown.propTypes.menu,
    position: Dropdown.propTypes.position,
    triggerLabel: oneOfType([string, node]),
    icon: node,
    tooltip: node,
};

export default SellerDropdown;
